import React from "react";
import { FormattedMessage } from "react-intl";
import { IssueBox } from "./IssueBox";
import bandCss from "./MonthBand.module.css";
import css from "./SpecialIssuesBand.module.css";
export var SpecialIssuesBand = function (_a) {
    var issues = _a.issues, onIssueClick = _a.onIssueClick, onLinkedVolumeClick = _a.onLinkedVolumeClick;
    if (issues.length === 0)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: bandCss.band, "data-testid": "special-issues-band" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.matrix.specialIssuesBand" })),
        React.createElement("div", { className: css.row, "data-testid": "special-issues-band-issues" }, issues.map(function (iss) { return (React.createElement(IssueBox, { key: iss.id, issue: iss, onClick: onIssueClick, onLinkedVolumeClick: onLinkedVolumeClick })); }))));
};
